<template>
  <div class="model">
    <div class="home_system_info2" v-if="windowwidth <= 500">
      <div @click="show = !show">
        <p class="content">{{show?'隐藏公众号':'查看公众号'}}</p>
        <p>
          <i class="el-icon-arrow-down" v-if="!show"></i
          ><i class="el-icon-arrow-up" v-if="show"></i>
        </p>
      </div>
    </div>

    <div class="home_system">
      <!-- <div
        class="home_system_in flex"
        v-for="(item, index) in relatedLinksList"
        :key="item.id"
        @click="pathhref(item.linkUrl)"
      >
        <div class="home_system_icon">
          <img :src="$store.store.state.windonsrc + item.imgBase64" />
        </div>
        <div class="home_system_info">
          <p>{{ item.title }}</p>
        </div>
      </div> -->

      <div class="home_system_in flex" @click="goDownload" v-if="show">
        <div class="home_system_icon">
          <img src="../../static/images/common/home_icon3.png" />
        </div>
        <div class="home_system_info">
          <p>下载中心</p>
        </div>
      </div>
    </div>
    <div class="ewm" v-if="show">
      <img src="../../static/images/common/home_icon4.jpg" />
      <p>扫码关注公众号</p>
      <p class="returntop" @click="backTop">返回顶部></p>
    </div>
  </div>
</template>

<script>
import { linkQuery } from "@/request/api";
export default {
  name: "HelloWorld",
  data() {
    return {
      relatedLinksList: [],
      windowwidth: window.screen.width,
      show: false,
    };
  },
  mounted() {
    this.linkQuery_Fun();
    if (window.screen.width > 500) {
      this.show = true;
    }
  },

  methods: {
    backTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    goDownload() {
      window.sessionStorage.setItem("menutype", 1);
      this.$router.push({ path: "/download" });
    },
    pathhref(url) {
      window.open(url);
    },
    linkQuery_Fun() {
      // 相关链接
      let params = {
        blongToMenu: 393,
        pageSize: 50,
        pageNumber: 1,
      };
      linkQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.relatedLinksList = res.data.data.list;
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.model {
  position: fixed;
  right: 20px;
  top: 180px;
  z-index: 110000;
}

.home_system_in {
  width: 174px;
  height: 60px;
  background: #ffffff;
  border-radius: 10px;
  padding: 11px 10px;
  margin-bottom: 10px;
  box-shadow: 0px 0px 10px 0px rgba(41, 117, 211, 0.4);
  cursor: pointer;
}

.home_system_icon {
  width: 34px;
  height: 34px;
  margin-right: 10px;
  margin-top: 5px;
}

.home_system_icon img {
  width: 100%;
}

.home_system_info {
  width: 103px;
  font-size: 14px;
  padding-top: 9px;
}

.ewm {
  width: 146px;
  height: 200px;
  background: #2975d3;
  border-radius: 0px 0px 10px 10px;
  margin: 0 auto;
  margin-top: -9px;
  text-align: center;
  padding-top: 12px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.returntop {
  font-size: 16px;
  margin-top: 20px;
}
@media screen and (max-width: 1300px) {
  .model {
    top: 340px;
    right: 10px;
  }
  .home_system_in {
    width: 124px;
    height: 40px;
    line-height: 40rpx;
    padding: 4px 10px;
  }
  .ewm[data-v-0107ea6e] {
    width: 106px;
    height: 160px;
    background: #2975d3;
    border-radius: 0px 0px 10px 10px;
    margin: 0 auto;
    margin-top: -9px;
    text-align: center;
    padding-top: 12px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
  }
  .ewm img {
    width: 80%;
  }
  .returntop {
    font-size: 14px;
    margin-top: 10px;
  }
  .home_system_info {
    padding-top: 6px;
  }
  .home_system_icon {
    margin-right: 5px;
  }
  .home_system_info2 {
    width: 30px;
    height: 120px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(41, 117, 211, 0.4);
    cursor: pointer;
    border-radius: 10px;
    padding: 13px 5px;
    float: right;
    margin-bottom: 5px;
  }
  .home_system_info2 .content {
    writing-mode: tb-rl;
    text-align: center;
  }
  .home_system_info2 i{
    margin-left: 2px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/model.vue